module.exports = __webpack_public_path__ + "static/media/hardware.e22d2855.jpeg";